<template>
    <div class="w-full mx-auto px-4 pt-16 py-20" :class="context.isDarkMode ? 'bg-semidark-silver text-silver' : 'bg-white text-void'">
        <section class="w-full px-2 md:w-2/3 md:mx-auto py-20">
            <h1 class="text-3xl font-bold text-center mb-6">
                {{ translationHandler.translate('Privacy Policy Summary') }}</h1>

            <section class="space-y-6">
                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Who we are') }}</h2>
                    <p>
                        {{ translationHandler.translate('We are Cervo Digital, a website development agency, committed to user privacy even without a CNPJ at the moment.') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('What is this policy?') }}</h2>
                    <p>
                        {{ translationHandler.translate('Explains how we collect, use and protect the personal data of website users.') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Data we collect') }}</h2>
                    <ul class="list-disc list-inside">
                        <li>{{ translationHandler.translate('Name, email, phone, selected language (when provided by you)') }}</li>
                        <li>{{ translationHandler.translate('IP, browser of pages accessed (technical data)') }}</li>
                    </ul>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Why we use your data') }}</h2>
                    <ul class="list-disc list-inside">
                        <li>{{ translationHandler.translate('Respond to requests and provide services') }}</li>
                        <li>{{ translationHandler.translate('Improve website navigation') }}</li>
                        <li>{{ translationHandler.translate('Send communications if authorized') }}</li>
                    </ul>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Sharing') }}</h2>
                    <p>
                        {{ translationHandler.translate('We may share data with partners securely, only when necessary. We never sell data.') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Your rights') }}</h2>
                    <ul class="list-disc list-inside">
                        <li>{{ translationHandler.translate('Access and correct your data') }}</li>
                        <li>{{ translationHandler.translate('Request deletion') }}</li>
                        <li>{{ translationHandler.translate('Revoke consent') }}</li>
                    </ul>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Security') }}</h2>
                    <p>
                        {{ translationHandler.translate('We take technical measures to protect your data, but we recommend that you exercise caution when sharing information online.') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Cookies') }}</h2>
                    <p>
                        {{ translationHandler.translate('We use cookies to improve your experience. You can disable them in your browser settings.') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Updates') }}</h2>
                    <p>
                        {{ translationHandler.translate('We may update this policy. Whenever we do, we will inform you on the website.') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-xl font-semibold">
                        <i class="pi pi-circle-fill mr-2"></i>
                        {{ translationHandler.translate('Contact') }}</h2>
                    <p>
                        {{ translationHandler.translate('Para dúvidas, envie um e-mail para') }} <a :href="`mailto:${env('APP_PRIVACY_POLICY_MAIL')}`"
                            class="text-second-color hover:underline">{{ env('APP_PRIVACY_POLICY_MAIL') }}</a></p>
                </div>
            </section>

            <div class="flex gap-2 content-center primary-button w-full md:w-2/3 lg:w-2/5 grow-effect rounded-3xl px-4 shadow mt-10" @click="openPrivacyPolicyFile()">
                <span class="text-lg lg:text-2xl my-auto text-silver font-semibold mx-auto md:mx-0">
                    {{ translationHandler.translate('Download privacy policy', 'capitalize') }}
                </span>
                <i class="ml-auto text-silver pi pi-download border border-second-color rounded-full bg-second-color p-2 my-auto shadow"></i>
            </div>
        </section>
    </div>
</template>

<script setup>
import DomHandler from '@/composables/handlers/DomHandler';
import { onMounted } from 'vue';
import translationHandler from '@/composables/handlers/TranslationHandler';
import { env } from '@/composables/config';
import { useContextStore } from '@/stores/context';
import urlHandler from '@/composables/urlHandler';

const context = useContextStore();

onMounted(() => {
    DomHandler.scrollTop();
    DomHandler.enableScroll();
});

function openPrivacyPolicyFile() {
    urlHandler.openLink('/files/privacy_policy.pdf');
}
</script>